/* eslint-disable no-console */
// import { PRE_ELIGIBILITY_COMPANY_STAKEHOLDER_ID }
// from "../../containers/CompanyStakeholders/constants";
//import { COMPANY_STAKEHOLDER_ID } from "../../containers
// /PostEligibilityCompanyStakeholders/constants";

import {
  PRE_ELIGIBILITY_COMPANY_SIGNATORY_ID,
  PRE_ELIGIBILITY_FINAL_QUESTIONS_COMPANY_ID,
  STEP_STATUS
} from "../../constants";

export const getCompletedSteps = state => state.completedSteps || [];

export const getCompanySteps = state =>
  getCompletedSteps(state).filter(
    ({ flowId }) => flowId === PRE_ELIGIBILITY_FINAL_QUESTIONS_COMPANY_ID
  );

export const getSignatoriesSteps = state =>
  getCompletedSteps(state).filter(({ flowId }) =>
    flowId.includes(PRE_ELIGIBILITY_COMPANY_SIGNATORY_ID)
  );

export const getStakeholderSteps = (state, selectedflowId = "") => {
  return getCompletedSteps(state).filter(({ flowId }) => flowId.startsWith(selectedflowId));
};

export const createGetIsStakeholderStepsCompleted = (stakeholderId, selectedFlowId) => state => {
  return !getStakeholderSteps(state, selectedFlowId).some(
    ({ flowId, status }) =>
      flowId === `${selectedFlowId}${stakeholderId}` && status !== STEP_STATUS.COMPLETED
  );
};

export const getIsAllStakeholdersStepsCompleted = selectedFlowId => state => {
  const stakeholderSteps = getStakeholderSteps(state, selectedFlowId);
  const result = stakeholderSteps.every(({ status }) => status === STEP_STATUS.COMPLETED);

  return stakeholderSteps.length > 0 && result;
};

export const getIsAnyStakeholderStepsCompleted = selectedFlowId => state =>
  !Object.values(
    getStakeholderSteps(state, selectedFlowId).reduce(
      (acc, { flowId, status }) => ({
        ...acc,
        [flowId]: acc[flowId] || status !== STEP_STATUS.COMPLETED
      }),
      {}
    )
  ).some(Boolean);

export const getstakeholderIdWithUnCompletedSteps = selectedFlowId => state => {
  const step =
    getStakeholderSteps(state, selectedFlowId).find(
      item => item.status !== STEP_STATUS.COMPLETED
    ) || {};

  return step.flowId ? step.flowId.split(selectedFlowId)[1] : null;
};

export const getIsAllStakeholderStepsCompletedExceptCurrent = (
  stakeholderId,
  selectedFlowId
) => state => {
  const allStepsExceptCurrent = getStakeholderSteps(state, selectedFlowId).filter(
    ({ flowId }) => flowId !== stakeholderId
  );

  return allStepsExceptCurrent.every(({ status }) => status === STEP_STATUS.COMPLETED);
};

export const getIsRevisitStakeholder = stakeholderId => state => {
  let sigsteps = getCompletedSteps(state).filter(
    ({ flowId, step, status }) =>
      flowId === stakeholderId && step === 6 && status === STEP_STATUS.RESET
  );
  return sigsteps && sigsteps.length > 0 ? true : false;
};
